import axios from 'axios'

export const getUnleashForCDN = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_UNLEASH_CDN_URL}/toggles.json`
    )
    const json = response.data

    return json.features
      .filter((feature) =>
        feature.strategies.some(
          (strategy) => strategy?.constraints?.length === 0
        )
      )
      .map((feature) => ({
        name: feature.name,
        enabled: feature.enabled,
        variant: feature.variants[0] && {
          name: feature.variants[0]?.name,
          enabled: true,
          payload: {
            type: feature.variants[0]?.payload?.type,
            value: feature.variants[0]?.payload?.value,
          },
        },
      }))
  } catch (error) {
    return []
  }
}
